<template>
  <body>
    <div class="clearfix"></div><!--ie7兼容-->
    <!--内容-->
    <div id="index-main" >
      <div id="index-content" class="clearfix">
        <div id="page">
          <!--***************第1屏*****************-->
          <div class="section" id="section1">
            <ul class="selection-ul">
              <li class="section-1-icon-7">
                  <span class="icon7" id="section_icon_7">
                    <img src="../../static/images/7.png" width="100%"/>
                  </span>
              </li>
              <li class="section-1-icon-6">
                  <span class="icon6" id="section_icon_6">
                    <img src="../../static/images/6.png" width="100%"/>
                  </span>
              </li>
              <li class="section-1-icon-5">
                  <span class="icon5" id="section_icon_5">
                    <img src="../../static/images/5.png" width="100%"/>
                  </span>
              </li>
              <li class="section-1-icon-4">
                  <span class="icon4"  id="section_icon_4">
                    <img src="../../static/images/4.png" width="100%"/>
                  </span>
              </li>
              <li class="section-1-icon-3">
                  <span class="icon3"  id="section_icon_3">
                    <img src="../../static/images/3.png" width="100%"/>
                  </span>
              </li>
              <li class="section-1-icon-2">
                  <span class="icon2"  id="section_icon_2">
                    <img src="../../static/images/2.png" width="100%"/>
                  </span>
              </li>
              <li class="section-1-icon-1">
                  <span class="icon1"  id="section_icon_1">
                    <img src="../../static/images/1.png" width="100%"/>
                  </span>
              </li>
            </ul>
            <div class="section-1-tit section-1-tit4" id="section_1_tit4" >让小白也懂买保险</div>
            <div class="section-1-tit section-1-tit7" id="section_1_tit7" >畅游中国 安全与美景随行</div>
            <div class="section-1-tit section-1-tit6" id="section_1_tit6" >带份保险，轻松玩转地球</div>
            <div class="section-1-tit section-1-tit5" id="section_1_tit5" >家庭财产也要上把“锁”</div>
            <div class="section-1-tit section-1-tit3" id="section_1_tit3" >生活、工作、出行全方面保障</div>
            <div class="section-1-tit section-1-tit2" id="section_1_tit2">团体投保</div>
            <div class="section-1-tit section-1-tit1" id="section_1_tit1" >
              <a href="https://chexian.zhongan.com/index?business_id=30055008010&utm_source=zyggbz" target="_blank" class="auto">
                <div class="auto-tit">
                  <!-- <img class="autoLogo" src="../../static/images/autoLogo.png" /> -->
                  <span>保骉车险</span>
                </div>
                <div class="auto-info">
                  众安平安联合承保商业险，平安承保交强险
                </div>
              </a>
            </div>
          </div>
          <!--***************第2屏*****************-->
          <div class="section" style="overflow: hidden;" id="section2">
            <div class="section_content">
              <h2 class="section-2-tit">
                狂风暴雨&nbsp照样买单
              </h2>
              <p class="section-2-p">不论天气无常，还是您身在远方，无需见面，一个链接，客户自动买单（电子保单,<span>奖励高达35%</span>，T+0实时结算）</p>
              <div class="section-2-img">
                <img src="../../static/images/section2img.png"  />
              </div>
            </div>
          </div>
          <!--***************第3屏*****************-->
          <div class="section">
            <div class="section_content">
              <h2 class="section-3-tit">
                微信分享,坐收奖励
              </h2>
              <p class="section-3-p">小白APP与微信、QQ等主流社交工具互联互通，您的产品链接分享出去，经过好友无数转发，只要有保单成交，奖励都算给您！（专属链接，智能核算）</p>
              <div class="section-3-img">
                <img src="../../static/images/section3img.png"  />
              </div>
            </div>
          </div>
          <!--***************第4屏*****************
          <div class="section">
            <div class="section_content">
              <h2 class="section-4-tit">
                保单成交 自动获客
              </h2>
              <p class="section-4-p">好友将您的产品链接分享给身边人，只要有成交，客户资料都同步给您，客源滚滚，助您二次开发签大单！</p>
              <div class="section-4-img">
                <img src="../../static/images/section4img.png"  />
              </div>
            </div>
          </div>-->
          <!--***************第5屏*****************-->
          <div class="section">
            <div class="section_content">
              <h2 class="section-5-tit">
                邀请伙伴 一起发展
              </h2>
              <p class="section-5-p">如果您身边的伙伴也想成为推广达人，欢迎邀请一起来下载小白app，业绩关联奖励，关系终生有效！</p>
              <div class="section-5-img">
                <img src="../../static/images/section5img.png"  />
              </div>
              <div class="download">
                <a @click="jump()">立即下载</a>
              </div>
            </div>
          </div>
        </div>
        <div id="menu">
          <ul>
            <li data-menuanchor="page1">
              <a href="#page1"></a>
            </li>
            <li data-menuanchor="page2"  >
              <a href="#page2" ></a>
            </li>
            <li data-menuanchor="page3">
              <a href="#page3" ></a>
            </li>
            <li data-menuanchor="page4">
              <a href="#page4" ></a>
            </li>
            <!-- <li data-menuanchor="page5">
              <a href="#page5"></a>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
  </body>
</template>
<script>
    import '../../static/js/jquery.fullPage.js'
    import '../../static/js/172.js'
    export default {
        name: "indexFirst",
        data() {
            return{
            }
        },

        methods: {
            jump(){
                this.$router.push({name: 'download'});
            },
        },
        mounted() {
            let that = this;
            that.$('#page').fullpage({
                anchors: ['page1', 'page2', 'page3', 'page4','page5'],
                menu: '#menu',
                afterRender:function(){
                    that.$("#section1").addClass("section-in");
                },
                afterLoad: function(anchorLink, index){
                    if(index === '1'){
                        that.$("body").css("background-color","#ffffff");
                        that.$("#section1").css("overflow","visible");
                        that.$("#section_1_tit4").css("display","block");
                        that.$("#section1").addClass("section-in");
                    }
                    if(index === '2'){
                        that.$("body").css("background-color","#f9f9f9");
                        that.$("#section1").css("overflow","hidden");
                        that.$(".section-1-tit").css("opacity",0);
                        that.$("#section1").removeClass("section-in");
                    }
                    if(index === '3'){
                        that.$("body").css("background-color","#ffffff");
                    }
                    if(index === '4'){
                        that.$("body").css("background-color","#f9f9f9");
                    }
                    if(index === '5'){
                        that.$("body").css("background-color","#ffffff");
                    }
                }
            });
            that.$("#section_icon_7").mouseover(function(){
                that.$("#section_1_tit7").css("opacity",1);
                that.$("#section_1_tit7").css("display","block");
                that.$("#section_1_tit4").css("display","none");
                that.$("#section_1_tit7").siblings(".section-1-tit").css("opacity",0);
            });
            that.$("#section_icon_6").mouseover(function(){
                that.$("#section_1_tit6").css("opacity",1);
                that.$("#section_1_tit6").css("display","block");
                that.$("#section_1_tit4").css("display","none");
                that.$("#section_1_tit6").siblings(".section-1-tit").css("opacity",0);
            });
            that.$("#section_icon_5").mouseover(function(){
                that.$("#section_1_tit5").css("opacity",1);
                that.$("#section_1_tit5").css("display","block");
                that.$("#section_1_tit4").css("display","none");
                that.$("#section_1_tit5").siblings(".section-1-tit").css("opacity",0);
            });
            that.$("#section_icon_3").mouseover(function(){
                that.$("#section_1_tit3").css("opacity",1);
                that.$("#section_1_tit3").css("display","block");
                that.$("#section_1_tit4").css("display","none");
                that.$("#section_1_tit3").siblings(".section-1-tit").css("opacity",0);
            });
            that.$("#section_icon_2").mouseover(function(){
                that.$("#section_1_tit2").css("opacity",1);
                that.$("#section_1_tit2").css("display","block");
                that.$("#section_1_tit4").css("display","none");
                that.$("#section_1_tit2").siblings(".section-1-tit").css("opacity",0);
            });
            that.$("#section_icon_1").mouseover(function(){
                that.$("#section_1_tit1").css("opacity",1);
                that.$("#section_1_tit1").css("display","block");
                that.$("#section_1_tit4").css("display","none");
                that.$("#section_1_tit1").siblings(".section-1-tit").css("opacity",0);
            })
        }
    }
</script>

<style src="../../static/css/rcMain/index1.css" ></style>
<style src="../../static/css/rcMain/common.css" ></style>
<style scoped>
  #content{
    padding: 178px 0 60px;
    margin: 0 auto;
    overflow: auto;
    height: calc(100vh - 70px);
  }

  /deep/ .el-menu.el-menu--horizontal{
    border-bottom: none;
  }

  /deep/ .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/indexFirst.vue